Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;
var e = n(require("random-seed")),
  t = n(require("lodash.defaults"));
function n(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function r(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
var a = ["aged", "ancient", "autumn", "billowing", "bitter", "black", "blue", "bold", "broad", "broken", "calm", "cold", "cool", "crimson", "curly", "damp", "dark", "dawn", "delicate", "divine", "dry", "empty", "falling", "fancy", "flat", "floral", "fragrant", "frosty", "gentle", "green", "hidden", "holy", "icy", "jolly", "late", "lingering", "little", "lively", "long", "lucky", "misty", "morning", "muddy", "mute", "nameless", "noisy", "odd", "old", "orange", "patient", "plain", "polished", "proud", "purple", "quiet", "rapid", "raspy", "red", "restless", "rough", "round", "royal", "shiny", "shrill", "shy", "silent", "small", "snowy", "soft", "solitary", "sparkling", "spring", "square", "steep", "still", "summer", "super", "sweet", "throbbing", "tight", "tiny", "twilight", "wandering", "weathered", "white", "wild", "winter", "wispy", "withered", "yellow", "young"],
  o = ["art", "band", "bar", "base", "bird", "block", "boat", "bonus", "bread", "breeze", "brook", "bush", "butterfly", "cake", "cell", "cherry", "cloud", "credit", "darkness", "dawn", "dew", "disk", "dream", "dust", "feather", "field", "fire", "firefly", "flower", "fog", "forest", "frog", "frost", "glade", "glitter", "grass", "hall", "hat", "haze", "heart", "hill", "king", "lab", "lake", "leaf", "limit", "math", "meadow", "mode", "moon", "morning", "mountain", "mouse", "mud", "night", "paper", "pine", "poetry", "pond", "queen", "rain", "recipe", "resonance", "rice", "river", "salad", "scene", "sea", "shadow", "shape", "silence", "sky", "smoke", "snow", "snowflake", "sound", "star", "sun", "sun", "sunset", "surf", "term", "thunder", "tooth", "tree", "truth", "union", "unit", "violet", "voice", "water", "waterfall", "wave", "wildflower", "wind", "wood"],
  i = {
    delimiter: "-",
    tokenLength: 4,
    tokenHex: !1,
    tokenChars: "0123456789"
  },
  l = function () {
    function n() {
      var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, n), this.adjectives = r.adjectives || a, this.nouns = r.nouns || o, this.random = e.default.create(r.seed), this.config = (0, t.default)(r.defaults, i);
    }
    var l, s, d;
    return l = n, (s = [{
      key: "haikunate",
      value: function (e) {
        var n = (0, t.default)(e, this.config);
        !0 === n.tokenHex && (n.tokenChars = "0123456789abcdef");
        var r = this._randomElement(this.adjectives),
          a = this._randomElement(this.nouns);
        n.tokenLength || (n.tokenLength = 0);
        for (var o = "", i = 0; i < n.tokenLength; i++) o += this._randomElement(n.tokenChars);
        return [r, a, o].filter(function (e) {
          return !!e;
        }).join(n.delimiter);
      }
    }, {
      key: "_randomElement",
      value: function (e) {
        if (e) return e[this.random(e.length)];
      }
    }]) && r(l.prototype, s), d && r(l, d), n;
  }();
exports.default = l, module.exports = exports.default;